// material-ui
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import { useBranding } from 'contexts/BrandingContext';
import zoidesqLogo from 'assets/images/zoidesq.png';

// ==============================|| LOGO WITH TEXT ||============================== //

export default function MultiTenantLogoMain({ reverse }) {
  const { companyName, logo, brandColor } = useBranding();
  const role = localStorage.getItem('role');
  const isCompanyAdmin = role && role !== 'SUPER_ADMIN';
  const textColor = reverse ? '#ffffff' : '#0F172A';

  // Company admin with branding — show company logo + name
  if (isCompanyAdmin && (logo || companyName)) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
        {logo ? (
          <Avatar
            src={logo}
            alt={companyName}
            variant="rounded"
            sx={{ width: 32, height: 32, borderRadius: 1.5 }}
          />
        ) : (
          <Box sx={{
            width: 32, height: 32, borderRadius: 1.5,
            bgcolor: brandColor || '#0D9488',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '0.875rem' }}>
              {companyName?.charAt(0)?.toUpperCase() || 'Z'}
            </Typography>
          </Box>
        )}
        <Typography
          sx={{
            color: textColor,
            fontWeight: 700,
            fontSize: '1rem',
            lineHeight: 1.2,
            letterSpacing: '-0.02em',
            maxWidth: 140,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {companyName || 'Zoiteckh'}
        </Typography>
      </Box>
    );
  }

  // Default ZoidesQ logo for super admin or unauthenticated
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      <Box component="img" src={zoidesqLogo} alt="ZoidesQ" sx={{ width: 34, height: 34, objectFit: 'contain' }} />
      <Typography
        sx={{
          fontFamily: "'Antapani', 'Montserrat', sans-serif",
          color: reverse ? '#ffffff' : '#002C84',
          fontWeight: 800,
          fontSize: '1.3rem',
          lineHeight: 1,
          letterSpacing: '0.01em',
        }}
      >
        ZoidesQ
      </Typography>
    </Box>
  );
}
